import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/CCS_Logo.png'


const _hoisted_1 = {
  class: "d-flex justify-center",
  style: {"margin":"8px"}
}
const _hoisted_2 = {
  key: 0,
  class: "menu-header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.shouldHideDrawer)
      ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
          key: 0,
          app: "",
          style: {"border-right":"solid 1px #e0e0e0","padding-top":"36px"},
          permanent: ""
        }, {
          prepend: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_img, {
                class: "mx-auto",
                height: "40px",
                width: "68%",
                src: _imports_0
              })
            ]),
            _createVNode(_component_v_divider)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_ctx.currentSchool)
                ? (_openBlock(), _createBlock(_component_v_list, {
                    key: 0,
                    nav: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navMenuItems, (menu, m) => {
                        return (_openBlock(), _createElementBlock("div", { key: m }, [
                          (_ctx.shouldShowMenuHeader(menu))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(menu.i18nKey)), 1))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSchool?.applicationPlan.nurseryWeb.featureGroups.find(
                (f) => f.name == menu.name
              )?.features, (item, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (menu.features.some((m) => m.slug === item.slug))
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    to: menu.features.find((m) => m.slug == item.slug)?.path,
                                    active: _ctx.isMenuActive(menu.features.find((m) => m.slug == item.slug)?.path),
                                    style: _normalizeStyle(item.isEnabled ? '' : 'display: none;'),
                                    target: menu.features.find((m) => m.slug == item.slug)?.target,
                                    href: menu.features.find((m) => m.slug == item.slug)?.href,
                                    density: "compact",
                                    link: "",
                                    color: "primary",
                                    class: "pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t(`features.${item.slug}`)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "active", "style", "target", "href"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 1,
                    color: "primary",
                    class: "pa-1",
                    indeterminate: ""
                  }))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}